<template>
  <div class="form-page-wrapper" v-loading="pageLoading">
    <div>
      <search-dsp-slot-select
        v-model="tableParams.dspSlotId"
        style="margin-right: 50px"
        @change="changePageData"
      />
      <search-channel-select
        v-model="tableParams.channelId"
        style="margin-right: 50px"
      />
      <search-channel-slot-select
        v-model="tableParams.slotId"
        :channel-id="channelId"
        style="margin-right: 50px"
      />
      <el-select
        v-model="tableParams.deliveryStatus"
        clearable
        placeholder="选择投放状态"
        style="margin-right: 50px"
      >
        <el-option label="启动" value="0"></el-option>
        <el-option label="停止" value="1"></el-option>
      </el-select>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
      <el-button type="success" @click="back" style="float: right"
        >返回</el-button
      >
    </div>

    <div class="title">广告位信息</div>

    <el-row :gutter="10" class="info">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">DSP广告名称：</div>
        <div class="info__value">{{ adInfo.dspSlotName }}</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">DSP广告位编号：</div>
        <div class="info__value">{{ adInfo.dspSlotId }}</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">广告位code：</div>
        <div class="info__value">{{ adInfo.dspSlotCode || "-" }}</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">所属DSP：</div>
        <div class="info__value">{{ adInfo.dspName }}</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">广告位类型：</div>
        <div class="info__value">
          {{ slotTypeMap[adInfo.slotTypeId] || "-" }}
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">应用名称：</div>
        <div class="info__value">{{ adInfo.appName || "-" }}</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">预算类型：</div>
        <div class="info__value">
          {{ billingTypeMap[adInfo.billingType] || "-" }}
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">合作模式：</div>
        <div class="info__value">
          {{ settlementTypeMap[adInfo.settlementType] || "-" }}
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">QSP：</div>
        <div class="info__value">{{ adInfo.maxQps }}</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">上游预算：</div>
        <div class="info__value">
          {{
            adInfo.budgetNameIdList
              ? adInfo.budgetNameIdList
                  .map((item) => {
                    return item.budgetName;
                  })
                  .join("，")
              : "-"
          }}
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">限制量({{ dspFlowTypeMap[adInfo.dspFlowType] || '-' }})：</div>
        <div class="info__value">{{ adInfo.dspFlowSize }}</div>
      </el-col>
    </el-row>

    <div class="title">广告位配置列表</div>
    <div style="display: flex">
      <div style="flex: 0.5" @click="addConfig" class="add-config">
        新增广告配置
      </div>
      <div style="flex: 0.5" @click="togetherConfig" class="add-config">
        一键广告配置
      </div>
    </div>

    <el-table
      :data="tableData"
      height="80vh"
      :header-cell-style="{ background: '#fafafa' }"
      highlight-current-row
      :cell-style="tableRowClassName"
      :default-sort="{ prop: 'deliveryStatus', order: 'ascending' }"
      size="small"
      class="js-table"
      style="width: 100%"
    >
      <el-table-column
        v-for="(v, i) in checkColumns"
        :prop="v.field"
        :label="v.title"
        :width="v.width"
        :sortable="
          v.field === 'channelBidfloor' ||
          v.field === 'deduction' ||
          v.field === 'deliveryStatus' ||
          v.field === 'dividedInto' ||
          v.field === 'dspSlotId' ||
          v.field === 'flowSize' ||
          v.field === 'profitRate' ||
          v.field === 'slotOrder'
        "
        :min-width="v.minWidth"
        :key="i"
        align="center"
      >
        <template v-slot="scope">
<!--          <div v-if="v.field === 'putTime'">-->
<!--            <el-popover-->
<!--              placement="left"-->
<!--              :width="1000"-->
<!--              :show-after="200"-->
<!--              trigger="hover"-->
<!--            >-->
<!--              <template #reference>-->
<!--                <span style="color: #409eff; cursor: pointer">查看</span>-->
<!--              </template>-->
<!--              <put-time :value="scope.row[v.field]" :isAll="false" disabled />-->
<!--            </el-popover>-->
<!--          </div>-->
          <div v-if="v.field === 'deliveryStatus'">
            <el-switch
              v-model="scope.row.deliveryStatus"
              active-color="#13ce66"
              :active-value="0"
              :inactive-value="1"
              @change="upstate(scope.row)"
            />
          </div>
          <span v-else-if="v.field === 'isEvenly'">{{
            scope.row[v.field] ? "是" : "否"
          }}</span>
          <span v-else-if="v.field === 'flowType'">{{
            flowTypeList[scope.row[v.field]]
          }}</span>
          <span v-else-if="v.field === 'settlementType'">{{ settlementTypeMap[scope.row[v.field]] || '-' }}</span>
          <span v-else>{{ scope.row[v.field] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="145">
        <template v-slot="scope" align="center">
          <el-button
            v-if="scope.row.sort"
            @click="handleTop(scope.row, 0)"
            size="mini"
            >取消</el-button>
          <el-button
            v-if="!scope.row.sort"
            @click="handleTop(scope.row, 1)"
            size="mini"
            >置顶</el-button
          >
          <el-button @click="handleUpdate(scope.row)" type="success" size="mini"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      @close="close"
      :title="title + '配置'"
      width="1100px"
      append-to-body
    >
      <el-form
        :model="form"
        :rules="rules"
        hide-required-asterisk
        ref="form"

        label-position="left"
      >
        <div v-show="!ifTogether">选择投放预算</div>
        <el-form-item
          v-show="!ifTogether"
          class="item-width"
          style="width: 100%"
        >
          <div>
            <el-select
              v-model="channelId"
              clearable
              filterable
              :disabled="currentIndex"
              placeholder="请选择渠道名称"
              @change="
                getChannelSlotName(
                  { channelId: channelId, appType: appType },
                  slotName2
                )
              "
            >
              <el-option
                v-for="item in channelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="appType"
              :disabled="disabled"
              clearable
              placeholder="请选择设备类型"

              @change="
                getChannelSlotName(
                  { channelId: channelId, appType: appType },
                  slotName2
                )
              "
              style="margin-left: 50px"
            >
              <el-option
                v-for="item in appTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="slotIds"
              :disabled="currentIndex"
              clearable
              multiple
              filterable
              placeholder="请选择渠道广告位"
              style="margin-left: 50px"
            >
              <el-option
                v-for="item in slotList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- <el-cascader
            v-model="form.dspSlotId"
            @change="dspSlotChange"
            :options="channelList"
            :props="props"
            filterable
            :before-filter="beforefilter"
            placeholder="DSP名称 / DSP广告位"
            style="width: 100%; display: inline-block;"
            ref="cascader"/> -->
        </el-form-item>
        <div>
          <el-form-item
            v-show="!ifTogether"
            prop="slotOrder"
            style="display: inline-block; width: 23%"
          >
            <template v-slot:label>
              <div class="form-item__label">优先级</div>
            </template>
            <el-input v-model="form.slotOrder" placeholder="请输入优先级" />
          </el-form-item>
          <el-form-item
            style="display: inline-block; margin-left: 4%; width: 15%"
          >
            <template v-slot:label>
              <div class="form-item__label">限制量</div>
            </template>
            <el-select v-model="form.flowType">
              <el-option label="限制展示量" :value="1"></el-option>
              <el-option label="限制请求量" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            style="display: inline-block; margin-left: 2%; width: 15%"
            prop="flowSize"
          >
            <el-input v-model="form.flowSize" placeholder="输入限制量" />
          </el-form-item>
        </div>
        <div>
          <el-form-item
            style="display: inline-block; width: 23%"
            prop="channelBidfloor"
          >
            <template v-slot:label>
              <div class="form-item__label">
                渠道价格<span style="color: red; margin-left: 5px"
                  >{{ form.channelBidfloor / 100 }} : ecpm</span
                >
              </div>
            </template>
            <el-input
              v-model="form.channelBidfloor"
              placeholder="请输入渠道价格"
            />
          </el-form-item>
          <el-form-item
            style="display: inline-block; width: 23%; margin-left: 4%"
            prop="dspBidfloor"
          >
            <template v-slot:label>
              <div class="form-item__label">
                预算价格<span style="color: red; margin-left: 5px"
                  >{{ form.dspBidfloor / 100 }} : ecpm</span
                >
              </div>
            </template>
            <el-input v-model="form.dspBidfloor" placeholder="请输入预算价格" />
          </el-form-item>
          <el-form-item
            prop="profitRate"
            style="display: inline-block; margin-left: 4%; width: 23%"
          >
            <template v-slot:label>
              <div class="form-item__label">
                预留利润
                <el-tooltip placement="top">
                  <template #content>
                   <p style="color: red">利润设置 30(表示30%),设置 0 系统默认 37.5%</p>
                    ○ 公式：利润 = 成本 * (销售利润率 / (1 - 销售利润率))<br/>
                    ○ (渠道底价)100 + (100 * 0.3 / (1 - 0.3)) = 142 去请求预算
                  </template>
                  <i class="el-icon-warning"/>
                </el-tooltip>
              </div>
            </template>
            <el-input
              v-model="form.profitRate"
              type="number"
              placeholder="请输入预留利润"
            />
          </el-form-item>
        </div>
        <div>
          <el-form-item
            prop="profitRate"
            style="display: inline-block; width: 23%"
          >
            <template v-slot:label>
              <div class="form-item__label">限制QPS</div>
            </template>
            <el-input
              v-model="form.qps"
              type="number"
              placeholder="请输入限制QPS"
            />
          </el-form-item>
          <el-form-item
            prop="keyword"
            style="display: inline-block; margin-left: 4%; width: 50%"
          >
            <template v-slot:label>
              <div class="form-item__label">关键字过滤</div>
            </template>
            <el-input
              v-model="form.keyword"
              type="string"
              placeholder="可多填，用“，”隔开"
            />
          </el-form-item>
        </div>
        <div>
          <el-form-item
            prop="mediaMapId"
            style="display: inline-block; width: 77%"
          >
            <template v-slot:label>
              <div class="form-item__label">白名单包名/映射id</div>
            </template>
            <el-input
              v-model="form.mediaMapId"
              type="string"
              placeholder="可多填，用“，”隔开"
            />
          </el-form-item>
        </div>
        <div>
          <el-form-item
            prop="blackMapId"
            style="display: inline-block; width: 77%"
          >
            <template v-slot:label>
              <div class="form-item__label">黑名单包名/映射id</div>
            </template>
            <el-input
              v-model="form.blackMapId"
              type="string"
              placeholder="可多填，用“，”隔开"
            />
          </el-form-item>
        </div>
        <el-form-item label-width="100px">
          <template v-slot:label>
            <div>匀速投放:</div>
          </template>
          <el-radio v-model="form.isEvenly" :label="1">是</el-radio>
          <el-radio v-model="form.isEvenly" :label="0">否</el-radio>
        </el-form-item>
        <el-form-item label-width="100px">
          <template v-slot:label>
            <div>是否自动提价:</div>
          </template>
          <el-radio v-model="form.autoPrice" :label="1">是</el-radio>
          <el-radio v-model="form.autoPrice" :label="0">否</el-radio>
        </el-form-item>

        <el-form-item label-width="100px">
          <template v-slot:label>
            <div>是否秒针过滤:</div>
          </template>
          <el-radio v-model="form.rtaStatus" :label="1">是</el-radio>
          <el-radio v-model="form.rtaStatus" :label="0">否</el-radio>
        </el-form-item>

        <el-form-item v-if="form.rtaStatus == 1">
          <template v-slot:label>
            <div>限制秒针需求请求数:</div>
          </template>
          <el-input
            style="width: 160px; margin-left: 10px"
            v-model="form.secondHandSize"
            type="Number"
            placeholder="请输入内容"
          >
          </el-input>
        </el-form-item>
        <el-form-item label-width="100px">
          <template v-slot:label>
            <div>是否取消频控:</div>
          </template>
          <el-radio v-model="form.frequencyControlStatus" :label="1"
            >是</el-radio
          >
          <el-radio v-model="form.frequencyControlStatus" :label="0"
            >否</el-radio
          >
        </el-form-item>
        <el-form-item>
          <template v-slot:label>
            <div>品牌</div>
          </template>
          <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <div style="margin: 15px 0"></div>
          <el-checkbox-group
            v-model="model"
            @change="handleCheckedCitiesChange"
          >
            <template v-for="(item, index) in brandData" :key="index">
              <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
            </template>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="specificArea" label-width="80px">
          <template v-slot:label>
            <div>地理位置:</div>
          </template>
          <el-radio
            v-model="checkArea"
            :label="1"
            @change="handleAllChange"
            >全部</el-radio
          >
          <el-radio v-model="checkArea" :label="2">自定义</el-radio>
          <Addr
            v-if="checkArea === 2"
            :data="provData"
            :ids="areaId"
            @change="handleAddrChange"
          ></Addr>
        </el-form-item>
        <el-form-item prop="startTime" class="item-width">
          <template v-slot:label>
            <div class="form-item__label">投放时间</div>
          </template>

          <el-date-picker
            v-model="intervalTime"
            :shortcuts="shortcuts"
            unlink-panels
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%"
          />
        </el-form-item>

        <el-form-item prop="putTime" class="item-width">
          <template v-slot:label>
            <div class="form-item__label">投放时段</div>
          </template>
          <div style="display: inline-block">
            <put-time
              @change="getPutTime"
              :value="form.putTime"
              :isAll="isAll"
              style="line-height: 24px"
            />
          </div>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button @click="close" >取消</el-button>
        <el-button
          v-show="!ifTogether"
          @click="confirm"
          type="primary"

          :loading="submitLoading"
          >确定</el-button
        >
        <el-button
          v-show="ifTogether"
          type="primary"

          :loading="submitLoading"
          @click="togetherConfirm"
          >一键配置</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      v-model="dialogStatus2"
      :close-on-click-modal="false"
      append-to-body
      title="配置明细"
      width="30%"
      :before-close="handleClose"
    >
      <div style="text-align: center; font-size: 16px">
        你已配置秒针过滤功能<br />是否确认操作无误
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogStatus2 = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  addDspFlow,
  getDspFlow,
  upFlow,
  top,
  update,
  getOrder
} from '@/api/manage/dsp/dspFlow'
import { getProv } from '@/api/advertise/flow'
import { getChannelName, getChannelSlotName, getSlotSize } from '@/api/select'
import { getBrand } from '@/api/manage/plot/plot'
import { formatDate, NORM_DATE_PATTERN } from '@/util/format'
import SearchChannelSelect from '@/components/SearchChannelSelect'
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'
import SearchChannelSlotSelect from '@/components/SearchChannelSlotSelect'
import Addr from '@/components/addr'
import { settlementTypeMap } from '@/const/settlement-type'
import { slotTypeMap } from '@/const/slot-type'
import { appTypeList } from '@/const/app-type'
import { billingTypeMap } from '@/const/billing-type'
import PutTime from './components/putTime'

const form = {
  autoPrice: 0,
  channelBidfloor: 0,
  deduction: 1,
  dividedInto: 1,
  dspBidfloor: 1,
  endTime: undefined,
  flowId: 0,
  flowSize: 0,
  flowType: 1,
  isEvenly: 0,
  keyword: '',
  phoneBrand: undefined,
  profitRate: 0,
  putTime: undefined,
  qps: 0,
  requestLimits: undefined,
  frequencyControlStatus: 0,
  rtaStatus: 0,
  secondHandSize: '',
  slotOrder: 1,
  sort: 0,
  specificArea: '',
  startTime: undefined
}

export default {
  name: 'AdConfig',
  components: {
    SearchChannelSlotSelect,
    SearchChannelSelect,
    SearchDspSlotSelect,
    PutTime,
    Addr
  },
  data () {
    return {
      shortcuts: [{
        text: '一周',
        value: (() => {
          const end = new Date()
          const start = new Date()
          end.setTime(start.getTime() + 3600 * 1000 * 24 * 6)
          return [start, end]
        })()
      }, {
        text: '一个月',
        value: (() => {
          const end = new Date()
          const start = new Date()
          end.setTime(start.getTime() + 3600 * 1000 * 24 * 30)
          return [start, end]
        })()
      }, {
        text: '一年',
        value: (() => {
          const end = new Date()
          const start = new Date()
          end.setTime(start.getTime() + 3600 * 1000 * 24 * 365)
          return [start, end]
        })()
      }],
      pageLoading: false,
      tableParams: {},
      settlementTypeMap,
      slotTypeMap,
      billingTypeMap,
      appTypeList,
      title: '新增',
      channelId: undefined,
      adInfo: {},
      sizeMap: {},
      tableData: [],
      dspFlowTypeMap: { 0: '空', 1: '展示', 2: '请求' },
      checkColumns: [
        { field: 'deliveryStatus', title: '投放状态' },
        { field: 'channelName', title: '渠道名称' },
        { field: 'slotName', title: '广告位名称' },
        { field: 'channelBidfloor', title: '渠道价格' },
        { field: 'settlementType', title: '合作模式' },
        { field: 'flowSize', title: '预算流量' },
        { field: 'flowType', title: '流量类型' },
        { field: 'qps', title: 'QPS' },
        { field: 'isEvenly', title: '均匀投放' },
        { field: 'profitRate', title: '利润' },
        { field: 'slotOrder', title: '优先级' },
        { field: 'startTime', title: '开始投放时间', width: 70 },
        { field: 'endTime', title: '结束投放时间', width: 70 },
        { field: 'handlers', title: '最后操作人' }
      ],
      channelList: [],
      slotList: [],
      flowTypeList: ['', '限制展示量', '限制请求量', '限制点击量'],
      slotId: undefined,
      Limits: 'requestLimits',
      form: Object.assign({}, form),
      rules: {
        // startTime: [{ validator: timeValid, trigger: "change" }],
        channelBidfloor: [
          {
            required: true,
            message: '请输入渠道价格',
            trigger: 'blur',
            pattern: /^[0-9]*$/
          }
        ],
        putTime: [
          { required: true, message: '请选择投放时段', trigger: 'blur' }
        ],
        slotOrder: [
          {
            required: true,
            message: '请输入优先级',
            trigger: 'blur',
            pattern: /^[0-9]*$/
          }
        ],
        flowSize: [
          {
            required: true,
            message: '请输入日展示量',
            trigger: 'blur',
            pattern: /^[0-9]*$/
          }
        ],
        profitRate: [
          { required: true, message: '请输入价格系数', trigger: 'blur' }
        ],
        dividedInto: [
          { required: true, message: '请输入分成比例', trigger: 'blur' }
        ],
        dspBidfloor: [
          { required: true, message: '请输入分成比例', trigger: 'blur' }
        ],
        deduction: [
          { required: true, message: '请输入扣量比例', trigger: 'blur' }
        ]
      },
      currentIndex: false,
      disabled: false,
      dialogStatus: false,
      dialogStatus2: false,
      submitLoading: false,
      isAll: false,
      brandData: undefined,
      model: [],
      checkAll: false,
      appType: undefined,
      dspSlotId: undefined,
      slotIds: [],
      checkArea: 1,
      provData: [],
      areaId: undefined,
      ifTogether: false
    }
  },
  computed: {
    intervalTime: {
      get () {
        if (this.form.startTime && this.form.endTime) {
          return [this.form.startTime, this.form.endTime]
        }
        return []
      },
      set (newValue) {
        if (!newValue) {
          newValue = []
        }
        this.form.startTime = newValue[0]
          ? formatDate(newValue[0], NORM_DATE_PATTERN)
          : undefined
        this.form.endTime = newValue[1]
          ? formatDate(newValue[1], NORM_DATE_PATTERN)
          : undefined
      }
    }
  },
  created () {
    this.dspSlotId = JSON.parse(localStorage.getItem('dspSlotId'))
    this.getDspFlowDetail()
    // this.getSlotSize()
  },
  mounted () {
    getBrand().then((res) => {
      if (res.code === 200) {
        this.brandData = res.data
      }
    })
    getProv().then((res) => {
      const addrData = []
      for (var i = 0; i < res.data.length; i++) {
        const nodeParent = res.data[i]
        for (var k = 0; k < nodeParent.children.length; k++) {
          nodeParent.children[k].children = ''
        }
        addrData.push(nodeParent)
      }
      this.provData = addrData
    })
  },
  methods: {
    changePageData (id) {
      if (id) {
        this.dspSlotId = id
        this.getDspFlowDetail()
      }
    },
    toQuery () {
      debugger
      this.tableParams.dspSlotId = this.dspSlotId
      getDspFlow(this.tableParams).then((res) => {
        if (res.code === 200) {
          this.adInfo = res.data
          this.tableData = res.data.dspSlotOneFlowSetList || []
        }
      })
    },
    slotName (arr) {
      this.slotList = arr
    },
    slotName2 (arr) {
      const newArr = []
      arr.forEach((item) => {
        let isRepeat = true
        for (let i = 0; i < this.tableData.length; i++) {
          if (item.value === this.tableData[i].dspSlotId) {
            isRepeat = false
          }
        }
        if (isRepeat) {
          newArr.push(item)
        }
      })
      this.slotList = newArr
    },
    getDspFlowDetail () {
      localStorage.removeItem('appType')
      const dspSlotId = { dspSlotId: this.dspSlotId }
      getDspFlow(dspSlotId).then((res) => {
        if (res.code === 200) {
          this.adInfo = res.data
          this.tableData = res.data.dspSlotOneFlowSetList || []
          localStorage.setItem('appType', JSON.stringify(res.data.appType))
        }
        this.getChannelName()
      })
    },
    getSlotSize () {
      getSlotSize().then((res) => {
        if (res.code === 200) {
          res.data.forEach((item) => {
            this.sizeMap[item.sizeId] = item.slotSize
          })
        }
      })
    },
    handleTop (row, sort) {
      const state = {
        sort,
        flowId: row.flowId
      }
      top(state).then(() => {
        this.getDspFlowDetail()
      })
    },
    tableRowClassName (data) {
      if (data.row.sort === 1) {
        return 'background-color: #eeeeee'
      } else {

      }
    },
    handleAllChange () {
      this.form.specificArea = ''
      this.form.areaId = ''
      this.areaId = ''
    },
    upstate (row) {
      const state = {
        flowId: row.flowId,
        slotId: row.slotId,
        state: row.deliveryStatus
      }
      if (row.flowId) {
        upFlow(state)
      }
    },
    // 编辑
    handleUpdate (row) {
      this.row = row
      const appType = localStorage.getItem('appType')
      this.title = '修改'
      this.ifTogether = false
      this.currentIndex = true
      this.dialogStatus = true
      this.specificArea = row.specificArea
      this.areaId = row.areaId
      if (this.areaId) {
        this.checkArea = 2
      } else {
        this.checkArea = 1
      }
      const disId = JSON.parse(localStorage.getItem('tableParams'))
      if (disId.dspId === 2001) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      if (appType === 4) {
        this.appType = '其他'
      } else if (appType === 1) {
        this.appType = 'Android'
      } else if (appType === 2) {
        this.appType = 'ios'
      } else if (appType === 3) {
        this.appType = '鸿蒙'
      }
      this.$nextTick(() => {
        this.form = JSON.parse(JSON.stringify(row))
        this.slotIds = [Number.parseInt(this.form.slotId)]
        if (this.form.phoneBrand === '0') {
          this.checkAll = true
          this.handleCheckAllChange(true)
        } else if (this.form.phoneBrand) {
          this.model = this.form.phoneBrand.split(',').map((item) => {
            return Number(item)
          })
        }
        this.getChannelSlotName(
          { channelId: this.form.channelId },
          this.updateSlotDefult
        )
      })
    },
    updateSlotDefult (arr) {
      for (let i = 0; i < this.channelList.length; i++) {
        if (this.channelList[i].value === this.form.channelId) {
          this.channelId = this.form.channelId
          this.slotList = arr
          return
        }
      }
    },

    confirm () {
      if (this.intervalTime.length === 0) return this.$message.error('投放时间不能为空')
      if (this.form.flowSize === 0) return this.$message.error('限制量不能为0')
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.rtaStatus) {
            this.dialogStatus2 = true
          } else {
            this.submit()
          }
        }
      })
    },
    togetherConfirm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.rtaStatus) {
            this.dialogStatus2 = true
          } else {
            this.togetherSubmit()
          }
        }
      })
    },
    submit () {
      this.dialogStatus2 = false
      this.form.areaId = this.areaId
      const form = {
        dspSlotId: this.dspSlotId,
        matchSetFlowListRes: this.form
      }
      this.form.channelId = undefined
      this.form.putTime = this.form.putTime.substring(1)
      this.form.phoneBrand = undefined

      if (this.form.rtaStatus === 1) {
        if (isNaN(Number(this.form.secondHandSize))) {
          this.$message.error('输入值需为数字')
          return
        } else {
          if (this.form.secondHandSize < 0 || this.form.secondHandSize === 0) {
            this.$message.error('秒针需求请求数不可小于或等于0')
            return
          }
        }
      }
      if (!this.checkAll) {
        if (!this.model[0]) {
          this.form.phoneBrand = ''
        }
        for (let i = 0; i < this.model.length; i++) {
          if (i === 0) {
            this.form.phoneBrand = this.model[0].toString()
          } else {
            this.form.phoneBrand = this.form.phoneBrand + ',' + this.model[i]
          }
        }
      } else {
        this.form.phoneBrand = '0'
      }
      if (this.currentIndex) {
        form.slotId = this.form.slotId
        this.form.slotId = undefined
        update(form)
          .then((res) => {
            if (res.code === 200) {
              this.getDspFlowDetail()
              this.close()
            }
          })
          .catch((rej) => {
            this.$message.error(rej.msg || '提交错误，请联系管理员')
          })
      } else {
        form.slotIds = this.slotIds
        this.form.slotId = undefined
        addDspFlow(form)
          .then((res) => {
            if (res.code === 200) {
              this.getDspFlowDetail()
              this.close()
            }
          })
          .catch((rej) => {
            this.$message.error(rej.msg || '提交错误，请联系管理员')
          })
      }
    },
    togetherSubmit () {
      this.dialogStatus2 = false
      const form = {
        dspSlotId: this.dspSlotId,
        matchSetFlowListRes: this.form,
        slotId: 0,
        deliveryStatus: 0
      }
      this.form.channelId = undefined
      this.form.putTime = this.form.putTime.substring(1)
      this.form.phoneBrand = undefined

      if (this.form.rtaStatus === 1) {
        if (isNaN(Number(this.form.secondHandSize))) {
          this.$message.error('输入值需为数字')
          return
        } else {
          if (this.form.secondHandSize < 0 || this.form.secondHandSize === 0) {
            this.$message.error('秒针需求请求数不可小于或等于0')
            return
          }
        }
      }
      if (!this.checkAll) {
        if (!this.model[0]) {
          this.form.phoneBrand = ''
        }
        for (let i = 0; i < this.model.length; i++) {
          if (i === 0) {
            this.form.phoneBrand = this.model[0].toString()
          } else {
            this.form.phoneBrand = this.form.phoneBrand + ',' + this.model[i]
          }
        }
      } else {
        this.form.phoneBrand = '0'
      }
      // if (this.currentIndex) {
      // form.slotIds = this.slotIds;
      update(form)
        .then((res) => {
          if (res.code === 200) {
            this.getDspFlowDetail()
            this.close()
          }
        })
        .catch((rej) => {
          this.$message.error(rej.msg || '提交错误，请联系管理员')
        })
    },
    close () {
      this.resetForm()
      this.slotIds = undefined
      this.currentIndex = false
      this.isAll = false
      this.checkAll = false
      this.channelId = undefined
      this.model = []
      this.areaId = undefined
      this.areaId = ''
      this.checkArea = 1
      this.$nextTick(() => {
        this.dialogStatus = false
        this.title = '新增'
        this.ifTogether = false
      })
    },
    resetForm () {
      this.form = Object.assign({}, form)
      // this.$refs.cascader.$refs.panel.clearCheckedNodes()
      this.$refs.form.resetFields()
    },
    getPutTime (value) {
      this.form.putTime = value
      this.$refs.form.validateField('putTime')
    },
    getChannelName () {
      getChannelName().then((res) => {
        if (res.code === 200) {
          const arr = []
          res.data.forEach((item) => {
            const obj = { value: item.channelId, label: item.channelName }
            arr.push(obj)
          })
          this.channelList = arr
        }
      })
    },
    getChannelSlotName (params, resolve) {
      const disId = JSON.parse(localStorage.getItem('tableParams'))
      if (disId.dspId === 2001) {
        if (params.appType === '其他') {
          params.appType = 4
        } else if (params.appType === 'Android') {
          params.appType = 1
        } else if (params.appType === 'ios') {
          params.appType = 2
        } else if (params.appType === '鸿蒙') {
          params.appType = 3
        }
      } else {
        params.appType = localStorage.getItem('appType')
      }
      // params.channelType=this.adInfo.channelType
      getChannelSlotName(params).then((res) => {
        if (res.code === 200) {
          const arr = []
          if (!res.data.length) {
            return resolve([{ leaf: true, disabled: true }])
          }
          res.data.forEach((item) => {
            const obj = {
              value: item.slotId,
              label: item.slotName,
              leaf: true
            }
            arr.push(obj)
          })
          arr.reverse()
          resolve(arr)
        }
      })
    },
    handleAddrChange (info) {
      this.form.specificArea = info.label
      this.areaId = info.id
    },
    back () {
      this.$router.push({
        path: '/dsp/user/manage/dsp/ad'
      })
    },
    // 新增配置
    addConfig () {
      const appType = localStorage.getItem('appType')
      const disId = JSON.parse(localStorage.getItem('tableParams'))
      if (disId.dspId === 2001) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      if (appType === 4) {
        this.appType = '其他'
      } else if (appType === 1) {
        this.appType = 'Android'
      } else if (appType === 2) {
        this.appType = 'ios'
      } else if (appType === 3) {
        this.appType = '鸿蒙'
      }
      // this.appType = appType
      getOrder({ dspSlotId: this.dspSlotId }).then((res) => {
        if (res.code === 200 && res.data) {
          this.form.slotOrder = res.data + 1
        } else {
          this.form.slotOrder = 1
        }
      })
      this.dialogStatus = true
      this.ifTogether = false
      // this.appType = null
      this.isAll = true
    },
    togetherConfig () {
      this.title = '一键编辑'
      this.ifTogether = true
      const appType = localStorage.getItem('appType')
      const disId = JSON.parse(localStorage.getItem('tableParams'))
      if (disId.dspId === 2001) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      if (appType === 4) {
        this.appType = '其他'
      } else if (appType === 1) {
        this.appType = 'Android'
      } else if (appType === 2) {
        this.appType = 'ios'
      } else if (appType === 3) {
        this.appType = '鸿蒙'
      }
      // this.appType = appType
      getOrder({ dspSlotId: this.dspSlotId }).then((res) => {
        if (res.code === 200 && res.data) {
          this.form.slotOrder = res.data + 1
        } else {
          this.form.slotOrder = 1
        }
      })
      this.dialogStatus = true
      // this.appType = null
      this.isAll = true
    },

    handleCheckAllChange (val) {
      this.model = val
        ? this.brandData.map((item) => {
          return item.id
        })
        : []
    },
    handleCheckedCitiesChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.brandData.length
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.add-config {
  margin-top: 10px;
  text-align: center;
  line-height: 45px;
  color: #000000d9;
  border: 1px #ddd dashed;
  cursor: pointer;
}

.item-width {
  width: 50%;
  display: block;
}

.add-config:hover {
  color: #409eff;
  border: 1px #409eff dashed;
}

.form-page-wrapper {
  padding: 20px;
  background: #ffffff;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}

::v-deep .el-table__expand-column .cell {
  display: none;
}

.el-form-item ::v-deep .el-form-item__label {
  display: block;
}

// .el-form-item{
//   color:red
// }
.info {
  margin-bottom: 25px;
  color: #000000d9;
  font-size: 14px;
  line-height: 2;
}

.info__col {
  margin-bottom: 10px;
}

.info__label {
  display: inline-block;
}

.info__value {
  display: inline-block;
}
</style>
